import { Container, Typography as MuiTypograpy } from '@mui/material';
import { styled } from '@mui/material/styles';

import { SPENT_CHART_WIDTH_PX } from './constants';

export const RemainingBudgetContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0 24px;
`;

export const RemainingBudgetTypography = styled(MuiTypograpy)`
  color: ${({ theme }) => theme.palette.text.dark};
  font-size: 32px;
`;

export const SpentBudgetContainer = styled(Container)`
  position: relative;
  padding-bottom: 20px;
`;

export const SpentBudgetLegend = styled(Container)`
  position: absolute;
  bottom: 0;
  margin: 0 auto;
  width: ${SPENT_CHART_WIDTH_PX}px;
  color: ${({ theme }) => theme.palette.text.dark};
  text-align: center;
`;

export const SpentBudgetLegendValueText = styled(MuiTypograpy)`
  font-size: 18px;
  line-height: 18px;
`;

export const SpentBudgetLegendRefText = styled(MuiTypograpy)`
  font-size: 16px;
  line-height: 16px;
`;
